module.exports = __webpack_public_path__ + "img/team-product-bg.55ad2e0a.svg";